import React, { useState, useEffect, useMemo, useContext } from 'react'
import Grid from '@mui/material/Grid2'
import { Button, Box, Typography, TextField } from '@mui/material'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Autocomplete from '@mui/material/Autocomplete'
import ManageJob from './ManageJob'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import excel_img from '../../../asset/excel_img.png'
import location_1 from '../../../asset/location_1.png'
import { MuiFileInput } from 'mui-file-input'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { MantineReactTable } from 'mantine-react-table'
import plus_icon from '../../../asset/plus_icon.png'

// import { Box, Text } from '@mantine/core'
import { data, data2 } from './makeData'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Api from '../../../Api/Api'
import { TreeSelect } from 'antd'
import { v4 as uuidv4 } from 'uuid'
import SceneLocationDialog from './SceneLocation_dialog'
import ListItemText from '@mui/material/ListItemText'
import ListItemButton from '@mui/material/ListItemButton'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Slide from '@mui/material/Slide'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import dayjs from 'dayjs'
import 'dayjs/locale/ko'
import secureLocalStorage from 'react-secure-storage'
import Checkbox from '@mui/material/Checkbox'
import { useNavigate } from 'react-router-dom'
import AddSharpIcon from '@mui/icons-material/AddSharp'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Draggable from 'react-draggable'
import Loader from '../../../Components/Loading'
import ExportToExcel from '../../../Components/ExportToExcel'
import { DataContext } from '../../../Context/LocDataContext'

const Title = (props) => {
  // console.log('render')
  return <Typography>{props.title}</Typography>
}
function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  )
}
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const styles1 = {
  grid1: {
    padding: 4,
    background: '#2C2D33',
    borderRadius: '10px',
    border: '1px solid #afafaf',
    borderImageSlice: 1,
    borderImage:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  grid2: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 35,
    background: '#454546',
    borderBottom: '1px solid #000000',
    borderTop: '1px solid #000000',
  },
  Typography1: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: '28.96px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography2: {
    color: '#000000',
    fontFamily: 'Noto Sans KR',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '18.82px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography3: {
    fontFamily: 'Noto Sans KR',
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: '15.82px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    display: 'flex',
    justifyContent: 'flex-start',
    justifyItems: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },

  Typography4: {
    border: '1px solid',
    height: 56,
    color: '#ffffff',
    borderColor: '#CCCCCC',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 3,
  },
  TableCell1: {
    color: '#CCCCCC',
    borderBottom: '1px solid #CCCCCC',
    background:
      'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
  },

  TableCellHeader1: { background: '#2F2E41', color: '#ffffff', borderBottom: '1px solid #CCCCCC' },

  InputTextField1: {
    '& label': {
      // placeholder text color
      color: '#BCBDC4',
    },
    '& label.Mui-focused': {
      // 해당 input focus 되었을 때 placeholder text color
      // floatng label을 사용할 때 처리 필요하다
      // color: '#BCBDC4',
      color: '#BCBDC4',
    },

    '& label.Mui-error': {
      color: '#d32f2f',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#BCBDC4',
      // borderColor: '#000000',
      borderWidth: '0.15rem',
    },
    '& .MuiOutlinedInput-root': {
      color: '#BCBDC4',
      '& fieldset': {
        borderColor: '#BCBDC4',
      },
    },
    // MuiTypography-root MuiTypography-caption
    '& .MuiTypography-root': {
      color: '#BCBDC4',
      '& fieldset': {
        borderColor: '#BCBDC4',
      },
    },
  },
  Select1: {
    '& label': {
      color: '#e4e4e7',
    },
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      opacity: 0.8,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
    },
    '& .MuiInputBase-input': {
      color: '#ffffff',
    },
    '&:hover .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    '& .MuiTypography-root': {
      color: '#BCBDC4',
      '& fieldset': {
        borderColor: '#BCBDC4',
      },
    },

    color: '#ffffff',
    backdropFilter: 'blur(53px)',
    boxShadow: '-8px 4px 5px 0px #0000003d',
    borderRadius: '10px',
    background: '#171821',
    // border: '1px solid #afafaf',
    // borderImageSource:
    //   'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
}

const StyledTab = styled(Tab)(({ theme }) => ({
  color: '#807F88',
  fontFamily: 'Noto Sans KR',
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '28.96px',
  textAlign: 'left',
  textUnderlinePosition: 'from-font',
  textDecorationSkipInk: 'none',

  '&.Mui-selected': {
    fontWeight: 700,
    color: '#FFFFFF',
    borderBottom: '7px solid',
    // border색깔 시작
    borderImage: 'linear-gradient(89.58deg, #628eff 10%, #8740cd 57.32%, #580475 99.08%)',
    borderImageSlice: 1,
    // border색깔 끝
  },
  '&:hover': {
    fontWeight: 700,
    color: '#FFFFFF',
  },
}))

export default function SceneInfo() {
  const loginId = secureLocalStorage.getItem('loginId')
  const navigate = useNavigate()
  const [loadingFlag, setLoadingFlag] = useState(false)
  //시설
  const [regButtonDisable, setRegButtonDisable] = React.useState(false)
  const [value, setValue] = React.useState('1')
  const [file, setFile] = React.useState()
  const [OrgData, setOrgData] = useState([])
  const [resultImg, setResultImg] = useState('')
  const [fileName, setFileName] = useState('')
  const [inputLocationName, setInputLocationName] = useState('')
  const [locationList, setLocationList] = useState([])
  // const [inputOrgid, setInputOrgid] = useState('')
  const { inputOrgid, inputLoid, setInputOrgid, setInputLoid } = useContext(DataContext)
  const [open, setOpen] = React.useState(false)

  //작업
  const [regButtonDisable2, setRegButtonDisable2] = React.useState(false)
  const [inputLocationName2, setInputLocationName2] = useState('')
  const [inputStartTime, setInputStartTime] = useState('')
  const [inputEndTime, setInputEndTime] = useState('')
  const [inputJobName, setInputJobName] = useState('')
  const [showRegImage, setShowRegImage] = useState('')
  const [dslList, setDslList] = useState([])
  const [inputDsi, setInputDsi] = useState([])
  const [jobinputDsi, setJobInputDsi] = useState([])
  const [jobList, setJobList] = useState([])
  const [jobLocationName, setJobLocationName] = useState('')

  const [openDialogLoction, setOpenDialogLoction] = useState(false)
  const [openDialogJob, setOpenDialogJob] = useState(false)

  const handleDialogLoctionOpen = () => {
    if (inputOrgid === null || inputOrgid === undefined || inputOrgid === '') {
      alert('부서가 선택되지 않았습니다.')
    } else {
      setOpenDialogLoction(true)
    }
  }
  const handleDialogLoctionClose = () => {
    setFile()
    setInputLocationName('')
    setResultImg('')
    setFileName('')
    setOpenDialogLoction(false)
  }

  const handleDialogJobOpen = () => {
    if (inputOrgid === null || inputOrgid === undefined || inputOrgid === '') {
      alert('부서가 선택되지 않았습니다.')
    } else {
      setOpenDialogJob(true)
    }
  }
  const handleDialogJobClose = () => {
    // jn: inputJobName,
    // loid: inputLocationName2,
    // uid: loginId,
    // orgid: inputOrgid,
    // sdt: inputStartTime,
    // edt: inputEndTime,
    // eqty: inputDsi,

    setInputJobName('')
    setInputLocationName2('')
    setInputStartTime('')
    setInputEndTime('')
    setInputDsi([])
    setShowRegImage('')
    // setFile()
    // setInputLocationName('')
    // setResultImg('')
    // setFileName('')
    setOpenDialogJob(false)
  }

  const handleJobInputDsi = (e, param) => {
    const {
      target: { value },
    } = e
    console.log('handleJobInputDsi value:', value)
    setJobInputDsi(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    )
    let copyList = [...jobList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.ji === param.ji
    })
    copyList[find1].eqty = typeof value === 'string' ? value.split(',') : value
    copyList[find1].detail.eqty = typeof value === 'string' ? value.split(',') : value
    setJobList(copyList)
  }

  const handleInputDsi = (event) => {
    const {
      target: { value },
    } = event
    console.log('handleInputDsi value:', value)
    setInputDsi(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    )
    // const values = e.target.value
    // console.log('handleInputDsi values:', values)
    // setInputDsi(values)
  }

  const handleJobInputStartTime = (e, param) => {
    const values = dayjs(e).format('YYYY-MM-DD HH:mm')
    let copyList = [...jobList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.ji === param.ji
    })
    copyList[find1].sdt = values
    copyList[find1].detail.sdt = values
    setJobList(copyList)
    console.log('handleJobInputStartTime values:', values)
    console.log('handleJobInputStartTime param:', param)
  }

  const handleJobInputEndTime = (e, param) => {
    //  const values= e.target.value
    const values = dayjs(e).format('YYYY-MM-DD HH:mm')
    let copyList = [...jobList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.ji === param.ji
    })
    copyList[find1].edt = values
    copyList[find1].detail.edt = values
    setJobList(copyList)
    console.log('handleJobInputEndTime values:', values)
  }
  const handleInputJobName = (e, param) => {
    let copyList = [...jobList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.ji === param.ji
    })
    copyList[find1].jn = e.target.value
    copyList[find1].detail.jn = e.target.value
    setJobList(copyList)
  }
  // mark
  const handleInputJobLocationName = (e, param) => {
    const values = e.target.value
    getDetailPanel(values).then(() => {
      console.log('handleInputJobLocationName values:', values)
      console.log('handleInputJobLocationName param:', param)
      setJobLocationName(values)
      try {
        console.log('handleInputJobLocationName try')
        let copyList = [...locationList]
        const find1 = copyList.findIndex((element, index, array) => {
          return element.loid === values
        })
        if (locationList[find1].detail !== undefined) {
          console.log('handleInputJobLocationName if')
          console.log('handleInputJobLocationName locationList[find1].detail:', locationList[find1].detail)

          let copyList2 = [...jobList]
          const find3 = copyList2.findIndex((element, index, array) => {
            return element.ji === param.ji
          })
          console.log('handleInputJobLocationName locationList[find1].detail.lon:', locationList[find1].detail.lon)
          console.log('handleInputJobLocationName copyList2[find3].detail:', copyList2[find3].detail)
          copyList2[find3].detail.lon = locationList[find1].detail.lon
          copyList2[find3].detail.loid = e.target.value
          copyList2[find3].detail.bf = locationList[find1].detail.bf
          copyList2[find3].lon = locationList[find1].detail.lon
          copyList2[find3].loid = e.target.value
          copyList2[find3].bf = locationList[find1].detail.bf
          setJobList(copyList2)
        }
      } catch (e) {
        console.log('handleInputJobLocationName catch error:', e)
      }
    })
  }

  const handleInputStartTime = (e) => {
    //  const values= e.target.value
    const values = dayjs(e).format('YYYY-MM-DD HH:mm')
    setInputStartTime(values)
    console.log('handleInputStartTime values:', values)
  }

  const handleInputEndTime = (e) => {
    //  const values= e.target.value
    const values = dayjs(e).format('YYYY-MM-DD HH:mm')
    setInputEndTime(values)
    console.log('handleInputEndTime values:', values)
  }

  const handleClickOpen = (param) => {
    console.log('handleClickOpen param:', param)
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const handleInputLocationName = (e, param) => {
    let copyList = [...locationList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.loid === param.loid
    })
    copyList[find1].lon = e.target.value
    setLocationList(copyList)
  }

  const handleInputLocationName2 = (e) => {
    const values = e.target.value
    console.log('handleInputLocationName2 values:', values)
    getDetailPanel(values).then(() => {
      setInputLocationName2(values)
      console.log('handleInputLocationName2 try')

      let copyList = [...locationList]
      const find1 = copyList.findIndex((element, index, array) => {
        return element.loid === values
      })
      if (locationList[find1].detail !== undefined) {
        setShowRegImage(locationList[find1].detail.bf)
      }
    })
  }

  const handleFile2 = (newValue, param) => {
    if (newValue !== undefined && newValue !== null) {
      let copyList = [...locationList]
      const find1 = copyList.findIndex((element, index, array) => {
        return element.loid === param.loid
      })

      const reader = new FileReader()

      reader.readAsDataURL(newValue)

      reader.onload = () => {
        copyList[find1].file = newValue
        copyList[find1].fname = newValue.name
        copyList[find1].bf = reader.result
        copyList[find1].detail.file = newValue
        copyList[find1].detail.fname = newValue.name
        copyList[find1].detail.bf = reader.result
        setLocationList(copyList)
        // console.log('called: ', reader.result)
      }
    }
  }

  const handleChange = (event, newValue) => {
    setRowSelection({})
    setValue(newValue)
  }

  const [rowSelection, setRowSelection] = React.useState({})
  const [rowSelection2, setRowSelection2] = React.useState({})

  React.useEffect(() => {
    //do something when the row selection changes...
    console.log('rowSelection:', rowSelection)

    let arr = Object.keys(rowSelection)
    console.log('arr:', arr)
    console.info({ rowSelection })
  }, [rowSelection])

  React.useEffect(() => {
    //do something when the row selection changes...
    console.log('rowSelection2:', rowSelection2)

    let arr = Object.keys(rowSelection2)
    console.log('arr2:', arr)
    console.info({ rowSelection2 })
  }, [rowSelection2])

  useEffect(() => {
    setInputOrgid('1110')
    getJobListorgid()
    Org()
  }, [])

  const handleFile = (newValue) => {
    setFile(newValue)
  }
  //부서 리스트
  const Org = async () => {
    try {
      const response = await Api.get('/api/v1/orgn')
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        setOrgData(response.data)
      }
      // console.log('response.data', response.data)
    } catch (e) {
      console.log('Org exception', e)
    }
  }
  //시설삭제
  const deleteLocation = async () => {
    const tempObject = { data: { uid: loginId } }
    let arr = Object.keys(rowSelection)
    if (arr.length > 0) {
      arr.map(async (item) => {
        try {
          const response = await Api.delete(`api/v1/loca/${item}`, tempObject)
          // const response = await Api.get('/api/v1/orgn', {
          //   withCredentials: true,
          // })
          if (response.status === 200) {
            console.log('deleteLocation OK , item:', item)
            getLocationList()
          }
          // console.log('response.data', response.data)
        } catch (e) {
          getLocationList()
          console.log('deleteLocation exception', e)
        }
      })
      setRowSelection({})
    } else {
      alert('시설이 선택되지 않았습니다.')
    }
  }

  //시설 리스트
  const getLocationList = async () => {
    // const headers = {
    //   istree: true,
    // }
    console.log('getLocationList inputOrgid:', inputOrgid)
    if (inputOrgid !== undefined && inputOrgid !== null && inputOrgid !== '') {
      setLoadingFlag(true)
      try {
        //todo
        // const response = await Api.get(`/api/v1/loca/?orgz_id=${inputOrgid}`)//원본
        const response = await Api.get(`api/v1/loca/list/Facility?orgid=${inputOrgid}`)

        //api/v1/loca/list/Facility?orgid=1110
        if (response.status === 200) {
          console.log('getLocationList:', response.data)
          setLocationList(response.data)
          setLoadingFlag(false)
        }
        // console.log('response.data Users', response.data)
      } catch (e) {
        console.log('getLocationList inputOrgid2:', inputOrgid)

        alert(`시설정보 불러오기 실패 ${e}`)
        setLoadingFlag(false)
        console.log('getLocationList exception', e)
      }
    }
  }

  const columns = React.useMemo(
    () => [
      {
        accessorKey: 'lon',
        header: '시설명',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
        size: 50,
      },
      {
        accessorKey: 'orglist',
        header: '상세위치',
        Cell: ({ cell }) =>
          cell.getValue()?.map((item, index) => (cell.getValue().length - 1 === index ? `${item}` : `${item}> `)),
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'dvloc',
        header: '설치 장비 개수',
        Cell: ({ cell }) => {
          return cell.getValue() !== null && cell.getValue() !== '' ? `${JSON.parse(cell.getValue()).length}대` : ''
        },
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'fname',
        header: '파일',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )

  const columns2 = React.useMemo(
    () => [
      {
        accessorKey: 'jn',
        header: '작업명',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'sdt',
        header: '작업시작시간',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'edt',
        header: '작업종료시간',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'lon',
        header: '시설명',
        // Cell: ({ cell }) => `${findLon(cell.row.original)}`,
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'orglists',
        header: '부서경로',
        Cell: ({ cell }) =>
          cell.getValue()?.map((item, index) => (cell.getValue().length - 1 === index ? `${item}` : `${item}> `)),
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'uid',
        header: '관리자',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )

  useEffect(() => {
    getLocationList()
    getJobListorgid()
  }, [inputOrgid])

  useEffect(() => {
    console.log('useEffect:', file)
    if (file !== undefined && file !== null) {
      convertToBase64()
    }
  }, [file])

  //이미지 변환
  const convertToBase64 = () => {
    setResultImg('')
    console.log('file:', file.name)
    const reader = new FileReader()

    reader.readAsDataURL(file)

    reader.onload = () => {
      setFileName(file.name)
      setResultImg(reader.result)
      // console.log('called: ', reader.result)
    }
  }
  //시설등록
  const registerLocation = async (e) => {
    setRegButtonDisable(true)
    // e.preventDefault()
    const uuid = uuidv4()
    const result = uuid.split('-')
    // console.log('uuid', result[0])
    try {
      if (
        inputLocationName !== undefined &&
        inputLocationName !== null &&
        inputLocationName !== '' &&
        inputOrgid !== null &&
        inputOrgid !== undefined &&
        inputOrgid !== ''
      ) {
        const regObject = {
          loid: result[0],
          lon: inputLocationName,
          orgid: inputOrgid,
          bf: resultImg,
          fname: fileName,
          uid: loginId,
        }
        // console.log('regObject', JSON.stringify(regObject))

        const response = await Api.post('/api/v1/loca', regObject)
        // const response = await Api.get('/api/v1/orgn', {
        //   withCredentials: true,
        // })
        if (response.status === 200) {
          setFile()
          setInputLocationName('')
          setResultImg('')
          setFileName('')
          getLocationList()
          handleDialogLoctionClose()
          alert('시설 등록됨')
        }
        if (response.status !== 200) {
          console.log('registerLocation error:', response)
        }
      } else {
        alert('부설 선택이 되지 않았거나 시설명이 없습니다.')
      }

      // console.log('response.data', response.data)
    } catch (e) {
      console.log('registerLocation exception', e)
    }
    getLocationList()
    setRegButtonDisable(false)
  }

  const modifyFlag = (param) => {
    let copyList = [...locationList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.loid === param.loid
    })
    copyList[find1].isFlag = true

    setLocationList(copyList)
    console.log('modifyFlag location list:', locationList)
  }

  const modifyFlagSave = async (param) => {
    try {
      let saveObject = param
      saveObject.uid = loginId
      const response = await Api.patch(`/api/v1/loca/${param.loid}`, saveObject)
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        alert('정보가 수정되었습니다.')
      }
      // console.log('response.data', response.data)
    } catch (e) {
      console.log('modifyFlagSave exception', e)
    }
    console.log('modifyFlagSave param:', param)
    modifyFlagCancel(param)
  }

  const modifyFlagCancel = (param) => {
    getLocationList()
    let copyList = [...locationList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.loid === param.loid
    })
    copyList[find1].isFlag = false
    setLocationList(copyList)
  }

  const modifyFlag2 = (param) => {
    console.log('modifyFlag2 inputOrgid:', inputOrgid)
    if (inputOrgid !== undefined && inputOrgid !== null && inputOrgid !== '') {
      console.log('modifyFlag2 param:')
      let copyList = [...jobList]
      const find1 = copyList.findIndex((element, index, array) => {
        return element.ji === param.ji
      })
      copyList[find1].isFlag = true

      setJobList(copyList)
      console.log('modifyFlag2 location list:', jobList)
    } else {
      alert('부서가 선택되지 않았습니다.')
    }
  }

  const modifyFlagSave2 = async (param) => {
    console.log('modifyFlagSave2 param:', param)
    console.log('modifyFlagSave2 param.detail:', param.detail)

    let copyList = param.detail
    let tempObject = []
    if (param.detail !== undefined && param.detail !== null && param.detail !== '') {
      param.detail.wkl.map((item) => {
        tempObject.push(item.workerId)
      })
      copyList.wkl = tempObject
    }
    try {
      const saveObject = copyList
      console.log('modifyFlagSave2 saveObject:', saveObject)

      const response = await Api.patch(`api/v1/job/${param.ji}`, saveObject)
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        getJobListorgid()
        setJobLocationName('')
        alert('작업 정보가 수정되었습니다.')
      }
      // console.log('response.data', response.data)
    } catch (e) {
      console.log('modifyFlagSave2 exception', e)
    }
    console.log('modifyFlagSave2 param:', param)
    modifyFlagCancel(param)
  }

  const modifyFlagCancel2 = (param) => {
    console.log('modifyFlagCancel2 param:', param)
    setJobLocationName('')
    getJobListorgid()
    getDetailPanelJob(param.ji)
    let copyList = [...jobList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.ji === param.ji
    })
    copyList[find1].isFlag = false
    setJobList(copyList)
  }

  useEffect(() => {
    getJobListorgid()
    getDslListorgid()
  }, [inputOrgid])

  const getDslListorgid = async () => {
    // setLoadingFlag(true)
    try {
      const response = await Api.get(`api/v1/dsl/${inputOrgid}`)
      if (response.status === 200) {
        setDslList(response.data)
        // setLoadingFlag(false)
      }
      console.log('getDslListorgid response.data:', response.data)
    } catch (e) {
      // setLoadingFlag(false)
      console.log('getDslListorgid exception', e)
    }
  }

  // const getJobList = async () => {
  //   // setLoadingFlag(true)
  //   try {
  //     const response = await Api.get(`api/v1/job`)
  //     if (response.status === 200) {
  //       setJobList(response.data)
  //       // setLoadingFlag(false)
  //     }
  //     console.log('getJobList response.data:', response.data)
  //   } catch (e) {
  //     // setLoadingFlag(false)
  //     console.log('getJobList exception', e)
  //   }
  // }

  const getJobListorgid = async () => {
    // setLoadingFlag(true)
    try {
      // const response = await Api.get(`api/v1/job/get_job_lists/by_orgid?orgid=${inputOrgid}`)
      const response = await Api.get(`api/v1/job/get_job_lists/base?orgid=${inputOrgid}`)
      // /api/v1/job/get_job_lists/base?orgid=1110
      if (response.status === 200) {
        setJobList(response.data)
        // setLoadingFlag(false)
      }
      console.log('getJobListorgid response.data:', response.data)
    } catch (e) {
      // setLoadingFlag(false)
      console.log('getJobListorgid exception', e)
    }
  }

  const postJob = async () => {
    setRegButtonDisable2(true)
    const uuid = uuidv4()
    const result = uuid.split('-')

    const jobObject = {
      ji: result[0],
      jn: inputJobName,
      loid: inputLocationName2,
      uid: loginId,
      orgid: inputOrgid,
      sdt: inputStartTime,
      edt: inputEndTime,
      eqty: inputDsi,
    }
    console.log('postJob jobObject:', jobObject)

    if (
      inputJobName !== undefined &&
      inputJobName !== null &&
      inputJobName !== '' &&
      inputLocationName2 !== null &&
      inputLocationName2 !== undefined &&
      inputLocationName2 !== '' &&
      inputOrgid !== null &&
      inputOrgid !== undefined &&
      inputOrgid !== '' &&
      inputStartTime !== null &&
      inputStartTime !== undefined &&
      inputStartTime !== '' &&
      inputEndTime !== null &&
      inputEndTime !== undefined &&
      inputEndTime !== '' &&
      inputDsi.length > 0
    ) {
      try {
        const response = await Api.post(`api/v1/job`, jobObject)
        if (response.status === 200) {
          alert('작업이 등록되었습니다.')
          getJobListorgid()
          handleDialogJobClose()
        }
        console.log('postJob response.data:', response.data)
      } catch (e) {
        alert('작업 등록에 실패했습니다.')
        console.log('postJob exception', e)
      }
    } else if (inputOrgid === null && inputOrgid === undefined && inputOrgid === '') {
      alert('부서가 선택되지 않았습니다.')
    } else if (inputDsi.length <= 0) {
      alert('장비유형이 선택되지 않았습니다.')
    } else {
      alert('빈칸이 있습니다.')
    }
    setRegButtonDisable2(false)
  }

  // 작업삭제
  const deleteJob = async () => {
    let arr = Object.keys(rowSelection)
    if (arr.length > 0) {
      arr.map(async (item) => {
        try {
          const response = await Api.delete(`api/v1/job/${item}`)
          // const response = await Api.get('/api/v1/orgn', {
          //   withCredentials: true,
          // })
          if (response.status === 200) {
            console.log('deleteJob OK , item:', item)
            alert('작업이 삭제 되었습니다.')
            getJobListorgid()
          }
          // console.log('response.data', response.data)
        } catch (e) {
          alert(`작업이 삭제 되지 않았습니다. ${e}`)
          getJobListorgid()
          console.log('deleteJob exception', e)
        }
      })
      setRowSelection2({})
    } else {
      alert('작업이 선택되지 않았습니다.')
    }
  }
  // mark
  const getDetailPanel = async (loid) => {
    let result
    console.log('getDetailPanel loid:', loid)
    // /api/v1/loca/62d26fb0
    let copyList = [...locationList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.loid === loid
    })

    try {
      const response = await Api.get(`/api/v1/loca/${loid}`)
      if (response.status === 200) {
        result = response.data
        copyList[find1].detail = result
        setLocationList(copyList)
        // setLoadingFlag(false)
      }
      console.log('getDetailPanel response.data:', response.data)
      console.log('getDetailPanel find1:', locationList[find1])
    } catch (e) {
      // setLoadingFlag(false)
      console.log('getDetailPanel exception', e)
    }
  }
  // mark
  const getDetailPanelJob = async (ji) => {
    let result
    ///api/v1/job/get_job_lists/detail?ji=eefda111
    console.log('getDetailPanelJob param:', ji)

    console.log('getDetailPanelJob ji:', ji)
    let copyList = [...jobList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.ji === ji
    })

    try {
      // /api/v1/job/get_job_lists/detail?ji=eefda111

      const response = await Api.get(`/api/v1/job/get_job_lists/detail?ji=${ji}`)

      if (response.status === 200) {
        result = response.data
        copyList[find1].detail = result
        setJobList(copyList)
        // setLoadingFlag(false)
      }
      console.log('getDetailPanelJob response.data:', response.data)
      console.log('getDetailPanelJob find1:', jobList[find1])
    } catch (e) {
      // setLoadingFlag(false)
      alert(`작업 세부정보를 읽는데 실패했습니다. ${e}`)
      console.log('getDetailPanelJob exception', e)
    }
  }

  // 페이지 이동 함수
  const handleButtonClick = (orgid, loid) => {
    console.log('handleButtonClick  orgid, loid:', orgid, loid)
    setInputOrgid(orgid)
    setInputLoid(loid)
    navigate('/User/IoTManage/GroupManage') // 이동할 페이지 경로
  }
  return (
    <div style={{ padding: 30 }}>
      <Grid container>
        <Grid size={12}>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <Box sx={{ width: 300, marginLeft: 3, marginBottom: 3 }}>
              <TreeSelect
                className="treeSelect"
                suffixIcon={<ArrowDropDownIcon />}
                style={{ marginTop: -22 }}
                value={inputOrgid}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                treeData={OrgData}
                treeTitleRender={(item) => {
                  return <Title title={item.orgn} />
                }}
                fieldNames={{ labal: 'orgid', key: 'orgid', value: 'orgid' }}
                placeholder="부서 선택"
                treeDefaultExpandAll
                onChange={(e) => setInputOrgid(e)}
              />
            </Box>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList
                  sx={{ marginLeft: 3 }}
                  TabIndicatorProps={{
                    style: {
                      display: 'none',
                    },
                  }}
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <StyledTab label="시설 관리" value="1" />
                  <StyledTab label="작업 관리" value="2" />
                </TabList>
              </Box>
              {/* 시설관리 */}
              <TabPanel value="1">
                <Grid container>
                  <Grid size={12} sx={styles1.grid1}>
                    <Box>
                      <Grid container sx={{ marginBottom: 2 }}>
                        <Grid size={6} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                          <Typography sx={styles1.Typography1}>시설목록</Typography>
                        </Grid>
                        <Grid size={6} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                          <Button
                            variant="contained"
                            sx={{
                              color: '#ffffff',
                              background: '#454546',
                              marginRight: 3,
                            }}
                            onClick={handleDialogLoctionOpen}
                          >
                            <img src={plus_icon} style={{ width: 25, height: 25, marginRight: 7 }}></img>
                            {/* <AddSharpIcon /> */}
                            현장 등록
                          </Button>
                          <Button
                            variant="contained"
                            sx={{ color: '#ffffff', background: '#454546', marginRight: 3 }}
                            onClick={() => deleteLocation()}
                          >
                            <DeleteOutlineIcon />
                            선택 삭제
                          </Button>
                          <ExportToExcel data={locationList} fileName={`시설관리목록`} />
                        </Grid>
                      </Grid>

                      {loadingFlag === true ? (
                        <>
                          <Loader loading={loadingFlag}></Loader>
                        </>
                      ) : (
                        <>
                          {/* mark */}
                          <MantineReactTable
                            className="mantine-Paper-root"
                            getRowId={(row) => row.loid}
                            onRowSelectionChange={setRowSelection}
                            state={{ rowSelection }}
                            selectDisplayMode="checkbox"
                            enableRowSelection={true}
                            enableMultiRowSelection={true}
                            enableColumnActions={false}
                            enableColumnFilters={false}
                            enablePagination={true}
                            enableSorting={false}
                            enableExpandAll={false}
                            columns={columns}
                            data={locationList}
                            enableFullScreenToggle={false}
                            paginationDisplayMode="pages"
                            // mantineTableBodyRowProps={({ row }) => ({
                            //   onClick: (event) => {
                            //     console.info(event, row.id);

                            //   },
                            //   sx: {
                            //     cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                            //   },
                            // })}
                            mantineExpandButtonProps={({ row }) => ({
                              onClick: (event) => {
                                console.info(event, row.id)
                                getDetailPanel(row.id)
                              },
                              sx: {
                                cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                              },
                            })}
                            renderDetailPanel={({ row }) => {
                              if (
                                row.original.detail !== undefined &&
                                row.original.detail !== '' &&
                                row.original.detail !== null
                              ) {
                                // console.log('test:', row.original.detail.lon)
                                return (
                                  <Grid
                                    container
                                    sx={{
                                      padding: 1,
                                    }}
                                  >
                                    <Grid size={12} sx={[styles1.grid2, { background: '#454546' }]}>
                                      <Typography sx={[styles1.Typography2, { marginLeft: 1, color: '#ffffff' }]}>
                                        상세정보
                                      </Typography>
                                    </Grid>

                                    <Grid
                                      size={12}
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        marginTop: 1,
                                        marginBottom: 3,
                                      }}
                                    >
                                      <div
                                        style={{
                                          marginLeft: 6,
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          width: 5,
                                          height: 5,
                                          border: '3px solid',
                                          borderRadius: '50%',
                                        }}
                                      ></div>
                                      <Typography
                                        style={{
                                          color: '#ffffff',
                                          marginLeft: 3,
                                          fontFamily: 'Noto Sans KR',
                                          fontSize: 17,
                                          fontWeight: 700,
                                          display: 'flex',
                                          justifyContent: 'flex-start',
                                        }}
                                      >
                                        현장 구성도
                                      </Typography>
                                    </Grid>
                                    <Grid size={12}>
                                      <Grid
                                        container
                                        sx={{
                                          padding: 3,
                                          borderRadius: '6px',
                                          border: '1px solid #dee2e6',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          justifyItems: 'center',
                                          alignContent: 'center',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <Grid
                                          size={3}
                                          sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            justifyItems: 'center',
                                            alignContent: 'center',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <Stack>
                                            <Box
                                              sx={{
                                                height: 115,
                                                width: 152,
                                                backgroundColor: '#2B2B36',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                justifyItems: 'center',
                                                alignContent: 'center',
                                                alignItems: 'center',
                                              }}
                                            >
                                              <img
                                                style={{
                                                  width: 131,
                                                  height: 95,
                                                }}
                                                src={row.original.detail.bf}
                                              ></img>
                                            </Box>
                                            <Typography
                                              sx={{
                                                color: '#ffffff',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                              }}
                                            >
                                              도면이미지
                                            </Typography>
                                          </Stack>
                                        </Grid>
                                        {/* mark 시설 세부정보 */}
                                        <Grid size={9}>
                                          <Grid container spacing={2}>
                                            <Grid size={6}>
                                              <Stack spacing={1}>
                                                <Typography sx={[styles1.Typography3, { color: '#ffffff' }]}>
                                                  시설명
                                                </Typography>
                                                {row.original.isFlag === false ||
                                                row.original.hasOwnProperty('isFlag') === false ? (
                                                  <Typography
                                                    sx={{
                                                      border: '1px solid',
                                                      height: 56,
                                                      color: '#ffffff',
                                                      borderColor: '#CCCCCC',
                                                      borderRadius: '5px',
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      paddingLeft: 3,
                                                    }}
                                                  >
                                                    {row.original.lon}
                                                  </Typography>
                                                ) : (
                                                  <TextField
                                                    sx={styles1.Select1}
                                                    value={row.original.lon}
                                                    onChange={(e) => handleInputLocationName(e, row.original)}
                                                  ></TextField>
                                                )}
                                              </Stack>
                                              <Stack spacing={1} sx={{ marginTop: 5 }}>
                                                <Typography
                                                  sx={[styles1.Typography3, { color: '#ffffff', marginTop: 5 }]}
                                                >
                                                  도면정보
                                                </Typography>
                                                {row.original.isFlag === false ||
                                                row.original.hasOwnProperty('isFlag') === false ? (
                                                  <Typography
                                                    sx={{
                                                      border: '1px solid',
                                                      height: 56,
                                                      color: '#ffffff',
                                                      borderColor: '#CCCCCC',
                                                      borderRadius: '5px',
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      paddingLeft: 3,
                                                    }}
                                                  >
                                                    {row.original.fname}
                                                  </Typography>
                                                ) : (
                                                  <Stack direction="row" spacing={1} sx={{ marginTop: 5 }}>
                                                    <MuiFileInput
                                                      sx={[styles1.Select1]}
                                                      value={row.original.file}
                                                      onChange={(e) => handleFile2(e, row.original)}
                                                    />
                                                  </Stack>
                                                )}
                                              </Stack>
                                            </Grid>
                                            <Grid size={6}>
                                              <Grid container spacing={1}>
                                                <Grid
                                                  size={6}
                                                  sx={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center',
                                                  }}
                                                >
                                                  <Typography sx={[styles1.Typography3]}>네트워크 장비구성</Typography>
                                                </Grid>
                                                <Grid
                                                  size={6}
                                                  sx={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                    alignItems: 'center',
                                                  }}
                                                >
                                                  {row.original.isFlag === false ||
                                                  row.original.hasOwnProperty('isFlag') === false ? (
                                                    ''
                                                  ) : (
                                                    <Button
                                                      sx={{
                                                        height: 30,
                                                        fontFamily: 'SUIT',
                                                        fontSize: 13,
                                                        borderRadius: '6px',
                                                        background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                                        marginTop: -2,
                                                      }}
                                                      variant="contained"
                                                      // onClick={() => handleClickOpen(row.original)}
                                                      onClick={() => navigate('/User/EnvManage/SceneLocation')}
                                                    >
                                                      장비 배치 변경
                                                    </Button>
                                                  )}
                                                </Grid>
                                                <Grid size={12}>
                                                  <Box
                                                    sx={{
                                                      color: '#ffffff',
                                                      height: 70,
                                                      border: '1px solid',
                                                      borderColor: '#CCCCCC',
                                                      borderRadius: '5px',
                                                      padding: 1.5,
                                                    }}
                                                  >
                                                    {row.original.dvloc &&
                                                    row.original.dvloc !== undefined &&
                                                    row.original.dvloc !== '' &&
                                                    row.original.dvloc !== null
                                                      ? JSON.parse(row.original.dvloc).map((item, index) =>
                                                          JSON.parse(row.original.dvloc).length - 1 === index
                                                            ? `${item.dname}`
                                                            : `${item.dname},`
                                                        )
                                                      : ''}
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid
                                      size={12}
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        marginTop: 7,
                                        marginBottom: 2,
                                      }}
                                    >
                                      <div
                                        style={{
                                          marginLeft: 6,
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          width: 5,
                                          height: 5,
                                          border: '3px solid',
                                          borderRadius: '50%',
                                        }}
                                      ></div>
                                      <Typography
                                        style={{
                                          color: '#ffffff',
                                          marginLeft: 3,
                                          fontFamily: 'Noto Sans KR',
                                          fontSize: 17,
                                          fontWeight: 700,
                                          display: 'flex',
                                          justifyContent: 'flex-start',
                                        }}
                                      >
                                        현장 장비 그룹 목록
                                      </Typography>
                                    </Grid>
                                    <Grid size={12}>
                                      <TableContainer component={Paper}>
                                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell align="center" sx={styles1.TableCellHeader1}>
                                                그룹명
                                              </TableCell>
                                              <TableCell align="center" sx={styles1.TableCellHeader1}>
                                                장비타입:장비명
                                              </TableCell>
                                              {row.original.isFlag === false ||
                                              row.original.hasOwnProperty('isFlag') === false ? (
                                                ''
                                              ) : (
                                                <TableCell align="center" sx={styles1.TableCellHeader1}>
                                                  그룹관리
                                                </TableCell>
                                              )}
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {row.original.detail.location_grp.map((row1, index) => (
                                              <TableRow
                                                key={index}
                                                // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                              >
                                                <TableCell
                                                  component="th"
                                                  scope="row"
                                                  align="center"
                                                  sx={styles1.TableCell1}
                                                >
                                                  {row1.group_name}
                                                </TableCell>
                                                <TableCell align="center" sx={styles1.TableCell1}>
                                                  {row1.group_devices.map((item, index) =>
                                                    row1.group_devices.length - 1 === index
                                                      ? `${item.device_type}:${item.device_name}`
                                                      : `${item.device_type}:${item.device_name},`
                                                  )}
                                                </TableCell>
                                                {row.original.isFlag === false ||
                                                row.original.hasOwnProperty('isFlag') === false ? (
                                                  ''
                                                ) : (
                                                  <TableCell
                                                    component="th"
                                                    scope="row"
                                                    align="center"
                                                    sx={[styles1.TableCell1, { borderBottom: '1px solid #CCCCCC' }]}
                                                  >
                                                    <Button
                                                      sx={{
                                                        borderRadius: '6px',
                                                        background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                                      }}
                                                      variant="contained"
                                                      onClick={() => {
                                                        handleButtonClick(
                                                          row.original.detail.orgid,
                                                          row.original.detail.loid
                                                        )
                                                      }}
                                                    >
                                                      이동
                                                    </Button>
                                                  </TableCell>
                                                )}
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </Grid>
                                    <Grid size={12} sx={{ display: 'flex', justifyContent: 'center', marginTop: 3 }}>
                                      {row.original.isFlag === false ||
                                      row.original.hasOwnProperty('isFlag') === false ? (
                                        <Button
                                          sx={{
                                            borderRadius: '6px',
                                            background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                          }}
                                          variant="contained"
                                          onClick={() => modifyFlag(row.original)}
                                        >
                                          시설 정보 수정
                                        </Button>
                                      ) : (
                                        <div>
                                          {' '}
                                          <Button
                                            sx={{
                                              borderRadius: '6px',
                                              background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                            }}
                                            variant="contained"
                                            onClick={() => modifyFlagSave(row.original)}
                                          >
                                            저장
                                          </Button>{' '}
                                          <Button
                                            sx={{
                                              borderRadius: '6px',
                                              background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                            }}
                                            variant="contained"
                                            onClick={() => modifyFlagCancel(row.original)}
                                          >
                                            취소
                                          </Button>
                                        </div>
                                      )}
                                    </Grid>
                                  </Grid>
                                )
                              } else {
                                return <Typography>{'loading...'}</Typography>
                              }

                              // {
                              //   row.original.detail !== undefined &&
                              //   row.original.detail !== '' &&
                              //   row.original.detail !== null ? (
                              //     <div>
                              //       <Typography>{row.original.detail.lon}</Typography>
                              //     </div>
                              //   ) : (
                              //     <div>Loding</div>
                              //   )
                              // }
                            }}
                            mantineTableHeadCellProps={{
                              sx: { color: '#ffffff', backgroundColor: '#2F2E41' },
                              align: 'start',
                            }}
                            mantineTableBodyCellProps={{
                              sx: {
                                color: '#CCCCCC',
                                background:
                                  'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
                              },
                              align: 'start',
                            }}
                            mantineDetailPanelProps={{
                              sx: {
                                color: '#ffffff',
                                background:
                                  'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
                              },
                            }}
                            mantineTopToolbarProps={{
                              sx: {
                                color: '#CCCCCC',
                                background: '#21222D',
                                // mantine-Stack-root
                                '.mantine-Alert-root': {
                                  color: '#ffffff',
                                  background: '#21222D',
                                },
                                '.mantine-Stack-root': {
                                  color: '#ffffff',
                                  background: '#21222D',
                                },
                              },
                            }}
                            mantineBottomToolbarProps={{
                              sx: {
                                background: '#21222D',
                                '.mantine-Input-input': {
                                  color: '#ffffff',
                                  background: '#21222D',
                                  borderColor: '#CCCCCC',
                                },
                                '.mantine-InputWrapper-label': {
                                  color: '#ffffff',
                                  background: '#21222D',
                                  borderColor: '#CCCCCC',
                                },
                              },
                            }}
                            mantinePaginationProps={{
                              sx: {
                                background: '#21222D',
                                '.mantine-UnstyledButton-root': {
                                  color: '#ffffff',
                                  background: '#21222D',
                                  borderColor: '#CCCCCC',
                                },
                              },
                            }}

                            // mantineSelectCheckboxProps={{
                            //   align: 'center',
                            //   color: 'violet', //makes all checkboxes use a different color other than the primaryColor
                            // }}
                          />
                        </>
                      )}

                      {/* 현장등록 다이아로그*/}
                      <Dialog
                        open={openDialogLoction}
                        onClose={handleDialogLoctionClose}
                        aria-labelledby="draggable-dialog-title"
                        PaperComponent={PaperComponent}
                        fullWidth
                        maxWidth="sm"
                      >
                        <DialogContent
                          sx={{
                            background: '#2F2E41',
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid size={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              <Typography sx={[styles1.Typography2, { marginTop: 2, color: '#ffffff', fontSize: 24 }]}>
                                현장등록
                              </Typography>
                            </Grid>

                            <Grid
                              size={12}
                              sx={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                marginTop: 1,
                              }}
                            >
                              <div
                                style={{
                                  color: '#ffffff',
                                  marginLeft: 16,
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  width: 5,
                                  height: 5,
                                  border: '3px solid',
                                  borderRadius: '50%',
                                }}
                              ></div>
                              <Typography
                                style={{
                                  color: '#ffffff',
                                  marginLeft: 3,
                                  fontFamily: 'Noto Sans KR',
                                  fontSize: 17,
                                  fontWeight: 700,
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                }}
                              >
                                현장 구성도
                              </Typography>
                            </Grid>

                            <Grid size={12}>
                              <Grid
                                container
                                sx={{
                                  marginLeft: 1,
                                  marginRight: 1,
                                  padding: 3,
                                  borderRadius: '6px',
                                  border: '1px solid #dee2e6',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  justifyItems: 'center',
                                  alignContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                <Grid
                                  size={3}
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    justifyItems: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Stack>
                                    <Box
                                      sx={{
                                        width: 450,
                                        height: 276,
                                        backgroundColor: '#2C2D33',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        justifyItems: 'center',
                                        alignContent: 'center',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <img
                                        style={{
                                          width: 416,
                                          height: 241,
                                        }}
                                        src={resultImg}
                                      ></img>
                                    </Box>
                                    <Typography
                                      sx={{
                                        color: '#ffffff',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginTop: 2,
                                        marginBottom: 4,
                                      }}
                                    >
                                      도면이미지
                                    </Typography>
                                  </Stack>
                                </Grid>
                                <Grid size={12}>
                                  <Grid container spacing={3}>
                                    <Grid
                                      size={6}
                                      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                    >
                                      <Stack>
                                        <Typography sx={[styles1.Typography3, { color: '#ffffff', marginBottom: 1 }]}>
                                          시설명
                                        </Typography>
                                        <TextField
                                          sx={[styles1.Select1, { marginRight: 5 }]}
                                          placeholder="시설명"
                                          variant="outlined"
                                          value={inputLocationName}
                                          onChange={(e) => setInputLocationName(e.target.value)}
                                        />
                                      </Stack>
                                    </Grid>
                                    <Grid
                                      size={6}
                                      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                    >
                                      <Stack sx={{ marginRight: 5 }}>
                                        <Typography sx={[styles1.Typography3, { color: '#ffffff', marginBottom: 1 }]}>
                                          도면정보
                                        </Typography>
                                        <Stack direction="row" spacing={1}>
                                          <Box
                                            sx={{
                                              color: '#CCCCCC',
                                              borderRadius: '6px',
                                              background: 'linear-gradient(180deg, #5E5F67 0%, #454546 100%);',
                                              width: 160,
                                              height: 54,
                                              fontFamily: 'SUIT',
                                              fontSize: 13,
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                            }}
                                          >
                                            &nbsp;이미지
                                            <br />
                                            추가하기
                                          </Box>
                                          <MuiFileInput
                                            sx={[styles1.Select1]}
                                            disabled={false}
                                            value={file}
                                            onChange={handleFile}
                                          />
                                        </Stack>
                                      </Stack>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </DialogContent>
                        <DialogActions sx={{ background: '#2F2E41' }}>
                          <Button
                            sx={{
                              marginBottom: 2,
                              borderRadius: '5px',
                              background: 'linear-gradient(180deg, #5E5F67 0%, #454546 100%)',
                            }}
                            variant="contained"
                            onClick={handleDialogLoctionClose}
                          >
                            취소
                          </Button>
                          <Button
                            disabled={regButtonDisable}
                            sx={{
                              marginRight: 3,
                              marginBottom: 2,
                              borderRadius: '5px',
                              background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                            }}
                            variant="contained"
                            onClick={() => registerLocation()}
                          >
                            현장등록
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Box>
                  </Grid>
                </Grid>
              </TabPanel>

              {/* 작업관리 */}
              <TabPanel value="2">
                {' '}
                <Grid container>
                  <Grid size={12} sx={styles1.grid1}>
                    <Box>
                      <Grid container sx={{ marginBottom: 2 }}>
                        <Grid size={6} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                          <Typography sx={styles1.Typography1}>작업목록</Typography>
                        </Grid>
                        <Grid size={6} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                          <Button
                            variant="contained"
                            sx={{
                              color: '#ffffff',
                              background: '#454546',
                              marginRight: 3,
                            }}
                            onClick={handleDialogJobOpen}
                          >
                            <AddSharpIcon />
                            작업 등록
                          </Button>
                          <Button
                            variant="contained"
                            sx={{ color: '#ffffff', background: '#454546', marginRight: 3 }}
                            onClick={() => deleteJob()}
                          >
                            <DeleteOutlineIcon />
                            선택 삭제
                          </Button>
                          <ExportToExcel data={jobList} fileName={`작업관리목록`} />
                        </Grid>
                      </Grid>
                      {loadingFlag === true ? (
                        <>
                          <Loader loading={loadingFlag}></Loader>
                        </>
                      ) : (
                        <>
                          {' '}
                          <MantineReactTable
                            getRowId={(row) => row.ji}
                            onRowSelectionChange={setRowSelection}
                            state={{ rowSelection }}
                            selectDisplayMode="checkbox"
                            enableRowSelection={true}
                            enableMultiRowSelection={true}
                            enableColumnActions={false}
                            enableColumnFilters={false}
                            enablePagination={true}
                            enableSorting={false}
                            enableExpandAll={false}
                            columns={columns2}
                            data={jobList}
                            enableFullScreenToggle={false}
                            paginationDisplayMode="pages"
                            mantineExpandButtonProps={({ row }) => ({
                              onClick: (event) => {
                                console.log('jobExpand Click:', event, row.id)
                                getDetailPanelJob(row.id)
                              },
                              sx: {
                                cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                              },
                            })}
                            // mark job
                            renderDetailPanel={({ row }) => {
                              if (
                                row.original.detail !== undefined &&
                                row.original.detail !== '' &&
                                row.original.detail !== null
                              ) {
                                return (
                                  <Grid container>
                                    <Grid size={12} sx={styles1.grid2}>
                                      <Typography sx={[styles1.Typography2, { marginLeft: 1, color: '#ffffff' }]}>
                                        상세정보
                                      </Typography>
                                    </Grid>

                                    <Grid
                                      size={12}
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        marginTop: 1,
                                        marginBottom: 3,
                                      }}
                                    >
                                      <div
                                        style={{
                                          marginLeft: 6,
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          width: 5,
                                          height: 5,
                                          border: '3px solid',
                                          borderRadius: '50%',
                                        }}
                                      ></div>
                                      <Typography
                                        sx={{
                                          color: '#ffffff',
                                          marginLeft: 3,
                                          fontFamily: 'Noto Sans KR',
                                          fontSize: 17,
                                          fontWeight: 700,
                                          display: 'flex',
                                          justifyContent: 'flex-start',
                                        }}
                                      >
                                        작업정보
                                      </Typography>
                                    </Grid>
                                    <Grid size={12}>
                                      <Grid
                                        container
                                        sx={{
                                          padding: 3,
                                          borderRadius: '6px',
                                          border: '1px solid #dee2e6',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          justifyItems: 'center',
                                          alignContent: 'center',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <Grid
                                          size={3}
                                          sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            justifyItems: 'center',
                                            alignContent: 'center',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <Stack>
                                            <Box
                                              sx={{
                                                height: 115,
                                                width: 152,
                                                backgroundColor: '#D9D9D9',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                justifyItems: 'center',
                                                alignContent: 'center',
                                                alignItems: 'center',
                                              }}
                                            >
                                              <img
                                                style={{
                                                  width: 131,
                                                  height: 95,
                                                }}
                                                src={row.original.detail.bf}
                                              ></img>
                                            </Box>
                                            <Typography
                                              sx={{
                                                color: '#CCCCCC',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                              }}
                                            >
                                              도면이미지
                                            </Typography>
                                          </Stack>
                                        </Grid>
                                        <Grid size={9}>
                                          <Grid container spacing={2}>
                                            <Grid size={6}>
                                              <Stack>
                                                <Typography sx={[styles1.Typography3, { marginBottom: 1 }]}>
                                                  작업명
                                                </Typography>
                                                {row.original.isFlag === false ||
                                                row.original.hasOwnProperty('isFlag') === false ? (
                                                  <Typography sx={styles1.Typography4}>{row.original.jn}</Typography>
                                                ) : (
                                                  <TextField
                                                    sx={styles1.Select1}
                                                    value={row.original.jn}
                                                    onChange={(e) => handleInputJobName(e, row.original)}
                                                  ></TextField>
                                                )}
                                              </Stack>
                                            </Grid>
                                            <Grid size={6}>
                                              <Stack>
                                                <Typography sx={[styles1.Typography3, { marginBottom: 1 }]}>
                                                  작업시설
                                                </Typography>
                                                <Stack direction="row" spacing={1}>
                                                  {/* <MuiFileInput disabled={false} value={file} onChange={handleFile} />
                                          <Button
                                            disabled={true}
                                            sx={{
                                              borderRadius: '6px',
                                              background: '#A2A2A8',
                                              width: 44,
                                              height: 54,
                                              fontFamily: 'SUIT',
                                              fontSize: 13,
                                            }}
                                            variant="contained"
                                            // onClick={Upload_file}
                                          >
                                            Upload
                                          </Button> */}
                                                  {row.original.isFlag === false ||
                                                  row.original.hasOwnProperty('isFlag') === false ? (
                                                    <Typography sx={[styles1.Typography4, { width: '100%' }]}>
                                                      {row.original.lon}
                                                    </Typography>
                                                  ) : (
                                                    <Select
                                                      value={jobLocationName}
                                                      onChange={(e) => handleInputJobLocationName(e, row.original)}
                                                      sx={[styles1.Select1, { width: 150 }]}
                                                    >
                                                      {locationList.map((item, index) => {
                                                        return (
                                                          <MenuItem key={index} value={item.loid}>
                                                            {item.lon}
                                                          </MenuItem>
                                                        )
                                                      })}
                                                    </Select>
                                                  )}
                                                </Stack>
                                              </Stack>
                                            </Grid>
                                            <Grid size={6}>
                                              <Stack>
                                                <Typography sx={[styles1.Typography3, { marginBottom: 1 }]}>
                                                  작업일시
                                                </Typography>
                                                {row.original.isFlag === false ||
                                                row.original.hasOwnProperty('isFlag') === false ? (
                                                  <Typography sx={[styles1.Typography4, { width: '100%' }]}>
                                                    {row.original.sdt}
                                                  </Typography>
                                                ) : (
                                                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                                                    <DemoContainer components={['DatePicker']}>
                                                      <DateTimePicker
                                                        format="YYYY-MM-DD HH:mm"
                                                        ampm={false}
                                                        sx={[styles1.Select1]}
                                                        onChange={(e) => handleJobInputStartTime(e, row.original)}
                                                      />
                                                    </DemoContainer>
                                                  </LocalizationProvider>
                                                )}
                                              </Stack>
                                            </Grid>
                                            <Grid size={6}>
                                              <Stack>
                                                <Typography sx={[styles1.Typography3, { marginBottom: 1 }]}>
                                                  &nbsp;{''}
                                                </Typography>
                                                {row.original.isFlag === false ||
                                                row.original.hasOwnProperty('isFlag') === false ? (
                                                  <Typography sx={[styles1.Typography4, { width: '100%' }]}>
                                                    {row.original.edt}
                                                  </Typography>
                                                ) : (
                                                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                                                    <DemoContainer components={['DatePicker']}>
                                                      <DateTimePicker
                                                        format="YYYY-MM-DD HH:mm"
                                                        ampm={false}
                                                        sx={[styles1.Select1]}
                                                        onChange={(e) => handleJobInputEndTime(e, row.original)}
                                                      />
                                                    </DemoContainer>
                                                  </LocalizationProvider>
                                                )}
                                              </Stack>
                                            </Grid>
                                            <Grid size={12}>
                                              <Stack>
                                                <Typography sx={[styles1.Typography3, { marginBottom: 1 }]}>
                                                  장비유형
                                                </Typography>
                                                {row.original.isFlag === false ||
                                                row.original.hasOwnProperty('isFlag') === false ? (
                                                  <div>
                                                    {row.original.detail.eqty !== null &&
                                                    row.original.detail.eqty !== undefined
                                                      ? row.original.detail.eqty.map((item, index) => {
                                                          return (
                                                            <Typography
                                                              key={index}
                                                              sx={[
                                                                styles1.Typography4,
                                                                { width: '100%', marginTop: 0.5 },
                                                              ]}
                                                            >
                                                              {item}
                                                            </Typography>
                                                          )
                                                        })
                                                      : 'null'}
                                                  </div>
                                                ) : (
                                                  <Select
                                                    multiple
                                                    value={jobinputDsi}
                                                    onChange={(e) => handleJobInputDsi(e, row.original)}
                                                    renderValue={(selected) => selected.join(', ')}
                                                    sx={[styles1.Select1, { width: '100%' }]}
                                                  >
                                                    {dslList.map((item, index) => {
                                                      return (
                                                        <MenuItem key={index} value={item.dsi}>
                                                          <Checkbox checked={jobinputDsi.includes(item.dsi)} />
                                                          {item.dsi}
                                                        </MenuItem>
                                                      )
                                                    })}
                                                  </Select>
                                                )}
                                              </Stack>
                                            </Grid>
                                            <Grid size={12}>
                                              {' '}
                                              <Grid container spacing={1}>
                                                <Grid
                                                  size={6}
                                                  sx={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center',
                                                  }}
                                                >
                                                  <Typography
                                                    sx={[styles1.Typography3, { marginTop: 3, marginBottom: 0.5 }]}
                                                  >
                                                    작업자 리스트
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  size={6}
                                                  sx={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                    alignItems: 'center',
                                                  }}
                                                ></Grid>
                                                <Grid size={12}>
                                                  <Box sx={[styles1.Typography4, { width: '100%' }]}>
                                                    {row.original.detail.wkl !== null &&
                                                    row.original.detail.wkl !== undefined
                                                      ? row.original.detail.wkl.map((item) => `${item.workerName},`)
                                                      : ''}
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                        <Grid
                                          size={12}
                                          sx={{ display: 'flex', justifyContent: 'center', marginTop: 3 }}
                                        >
                                          {row.original.isFlag === false ||
                                          row.original.hasOwnProperty('isFlag') === false ? (
                                            <Button
                                              sx={{
                                                borderRadius: '6px',
                                                background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                              }}
                                              variant="contained"
                                              onClick={() => modifyFlag2(row.original)}
                                            >
                                              작업 정보 수정
                                            </Button>
                                          ) : (
                                            <div>
                                              {' '}
                                              <Button
                                                sx={{
                                                  borderRadius: '6px',
                                                  background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                                }}
                                                variant="contained"
                                                onClick={() => modifyFlagSave2(row.original)}
                                              >
                                                수정
                                              </Button>{' '}
                                              <Button
                                                sx={{
                                                  borderRadius: '6px',
                                                  background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                                }}
                                                variant="contained"
                                                onClick={() => modifyFlagCancel2(row.original)}
                                              >
                                                취소
                                              </Button>
                                            </div>
                                          )}
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid
                                      size={12}
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        marginTop: 7,
                                        marginBottom: 2,
                                      }}
                                    >
                                      <div
                                        style={{
                                          marginLeft: 6,
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          width: 5,
                                          height: 5,
                                          border: '3px solid',
                                          borderRadius: '50%',
                                        }}
                                      ></div>
                                      <Typography
                                        style={{
                                          color: '#ffffff',
                                          marginLeft: 3,
                                          fontFamily: 'Noto Sans KR',
                                          fontSize: 17,
                                          fontWeight: 700,
                                          display: 'flex',
                                          justifyContent: 'flex-start',
                                        }}
                                      >
                                        현장 장비 목록
                                      </Typography>
                                    </Grid>
                                    <Grid size={12}>
                                      <TableContainer component={Paper}>
                                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell align="center" sx={styles1.TableCellHeader1}>
                                                근로자명
                                              </TableCell>
                                              <TableCell align="center" sx={styles1.TableCellHeader1}>
                                                장비타입:장비명
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {row.original.detail.wkl !== null && row.original.detail.wkl !== undefined
                                              ? row.original.detail.wkl.map((row1, index) => (
                                                  <TableRow
                                                    key={index}
                                                    // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                  >
                                                    <TableCell
                                                      component="th"
                                                      scope="row"
                                                      align="center"
                                                      sx={styles1.TableCell1}
                                                    >
                                                      {row1.workerName}
                                                    </TableCell>
                                                    <TableCell align="center" sx={styles1.TableCell1}>
                                                      {row1.deviceLists &&
                                                        row1.deviceLists.map((item, index) =>
                                                          row1.deviceLists.length - 1 === index
                                                            ? `${item.device_type}:${item.device_name}`
                                                            : `${item.device_type}:${item.device_name},`
                                                        )}
                                                    </TableCell>
                                                  </TableRow>
                                                ))
                                              : ''}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </Grid>
                                  </Grid>
                                )
                              } else {
                                return <Typography>Loading...</Typography>
                              }
                            }}
                            mantineTableHeadCellProps={{
                              sx: { color: '#ffffff', backgroundColor: '#2F2E41' },
                              align: 'start',
                            }}
                            mantineTableBodyCellProps={{
                              sx: {
                                color: '#CCCCCC',
                                background:
                                  'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
                              },
                              align: 'start',
                            }}
                            mantineDetailPanelProps={{
                              sx: {
                                color: '#ffffff',
                                background:
                                  'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
                              },
                            }}
                            mantineTopToolbarProps={{
                              sx: {
                                color: '#CCCCCC',
                                background: '#21222D',
                                // mantine-Stack-root
                                '.mantine-Alert-root': {
                                  color: '#ffffff',
                                  background: '#21222D',
                                },
                                '.mantine-Stack-root': {
                                  color: '#ffffff',
                                  background: '#21222D',
                                },
                              },
                            }}
                            mantineBottomToolbarProps={{
                              sx: {
                                background: '#21222D',
                                '.mantine-Input-input': {
                                  color: '#ffffff',
                                  background: '#21222D',
                                  borderColor: '#CCCCCC',
                                },
                                '.mantine-InputWrapper-label': {
                                  color: '#ffffff',
                                  background: '#21222D',
                                  borderColor: '#CCCCCC',
                                },
                              },
                            }}
                            mantinePaginationProps={{
                              sx: {
                                background: '#21222D',
                                '.mantine-UnstyledButton-root': {
                                  color: '#ffffff',
                                  background: '#21222D',
                                  borderColor: '#CCCCCC',
                                },
                              },
                            }}
                          />
                        </>
                      )}

                      {/* 작업등록 다이아로그*/}
                      <Dialog
                        open={openDialogJob}
                        onClose={handleDialogJobClose}
                        aria-labelledby="draggable-dialog-title"
                        PaperComponent={PaperComponent}
                        maxWidth={'1000px'}
                      >
                        <DialogContent
                          sx={{
                            background: '#2F2E41',
                          }}
                        >
                          <Grid container>
                            <Grid size={12} sx={[styles1.grid2, { background: '#2C2D33' }]}>
                              <Typography sx={[styles1.Typography2, { marginLeft: 1, color: '#ffffff' }]}>
                                작업등록
                              </Typography>
                            </Grid>
                            <Grid
                              size={12}
                              sx={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                marginTop: 1,
                                marginBottom: 3,
                              }}
                            >
                              <div
                                style={{
                                  color: '#ffffff',
                                  marginLeft: 16,
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  width: 5,
                                  height: 5,
                                  border: '3px solid',
                                  borderRadius: '50%',
                                }}
                              ></div>
                              <Typography
                                style={{
                                  color: '#ffffff',
                                  marginLeft: 3,
                                  fontFamily: 'Noto Sans KR',
                                  fontSize: 17,
                                  fontWeight: 700,
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                }}
                              >
                                현장 구성도
                              </Typography>
                            </Grid>
                            <Grid size={12}>
                              <Grid
                                container
                                sx={{
                                  marginLeft: 1,
                                  marginRight: 1,
                                  padding: 3,
                                  borderRadius: '6px',
                                  border: '1px solid #dee2e6',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  justifyItems: 'center',
                                  alignContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                <Grid
                                  size={3}
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    justifyItems: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Stack>
                                    <Box
                                      sx={{
                                        height: 115,
                                        width: 152,
                                        backgroundColor: '#D9D9D9',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        justifyItems: 'center',
                                        alignContent: 'center',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <img
                                        style={{
                                          width: 131,
                                          height: 95,
                                        }}
                                        src={showRegImage}
                                      ></img>
                                    </Box>
                                    <Typography
                                      sx={{
                                        color: '#ffffff',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                      }}
                                    >
                                      도면이미지
                                    </Typography>
                                  </Stack>
                                </Grid>
                                <Grid size={9}>
                                  <Grid container spacing={2}>
                                    <Grid size={12}>
                                      <Stack>
                                        <Typography sx={[styles1.Typography3, { color: '#ffffff', marginBottom: 1 }]}>
                                          작업시설
                                        </Typography>
                                        <Select
                                          value={inputLocationName2}
                                          onChange={handleInputLocationName2}
                                          sx={[styles1.Select1, { width: 150 }]}
                                        >
                                          {locationList.map((item, index) => {
                                            return (
                                              <MenuItem key={index} value={item.loid}>
                                                {item.lon}
                                              </MenuItem>
                                            )
                                          })}
                                        </Select>
                                      </Stack>
                                      <Stack>
                                        <Typography
                                          sx={[
                                            styles1.Typography3,
                                            { color: '#ffffff', marginBottom: 1, marginTop: 2 },
                                          ]}
                                        >
                                          작업명
                                        </Typography>
                                        <TextField
                                          sx={styles1.Select1}
                                          value={inputJobName}
                                          onChange={(e) => setInputJobName(e.target.value)}
                                        ></TextField>
                                      </Stack>

                                      <Typography
                                        sx={[styles1.Typography3, { color: '#ffffff', marginBottom: 1, marginTop: 2 }]}
                                      >
                                        장비유형
                                      </Typography>
                                      <Select
                                        multiple
                                        value={inputDsi}
                                        onChange={handleInputDsi}
                                        renderValue={(selected) => selected.join(', ')}
                                        sx={[styles1.Select1, { width: '100%' }]}
                                      >
                                        {dslList.map((item, index) => {
                                          return (
                                            <MenuItem key={index} value={item.dsi}>
                                              <Checkbox checked={inputDsi.includes(item.dsi)} />
                                              {item.dsi}
                                            </MenuItem>
                                          )
                                        })}
                                      </Select>
                                    </Grid>
                                    <Grid size={6}>
                                      <Stack>
                                        <Typography sx={[styles1.Typography3, { color: '#ffffff' }]}>
                                          작업일시
                                        </Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                                          <DemoContainer components={['DatePicker']}>
                                            <DateTimePicker
                                              format="YYYY-MM-DD HH:mm"
                                              ampm={false}
                                              sx={[styles1.Select1]}
                                              onChange={handleInputStartTime}
                                            />
                                          </DemoContainer>
                                        </LocalizationProvider>
                                      </Stack>
                                    </Grid>
                                    <Grid size={6}>
                                      <Stack>
                                        <Typography sx={[styles1.Typography3]}>&nbsp;{''}</Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                                          <DemoContainer components={['DatePicker']}>
                                            <DateTimePicker
                                              format="YYYY-MM-DD HH:mm"
                                              ampm={false}
                                              sx={[styles1.Select1]}
                                              onChange={handleInputEndTime}
                                            />
                                          </DemoContainer>
                                        </LocalizationProvider>
                                      </Stack>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </DialogContent>
                        <DialogActions sx={{ background: '#2F2E41' }}>
                          <Button
                            sx={{
                              borderRadius: '5px',
                              background: 'linear-gradient(30.45deg, #628EFF 1.58%, #8740CD 62.31%, #580475 115.89%)',
                            }}
                            variant="contained"
                            onClick={handleDialogJobClose}
                          >
                            취소
                          </Button>
                          <Button
                            disabled={regButtonDisable2}
                            sx={{
                              borderRadius: '5px',
                              background: 'linear-gradient(30.45deg, #628EFF 1.58%, #8740CD 62.31%, #580475 115.89%)',
                            }}
                            variant="contained"
                            onClick={() => postJob()}
                          >
                            작업등록
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Box>
                  </Grid>
                </Grid>
              </TabPanel>
            </TabContext>
          </Box>
        </Grid>
      </Grid>
    </div>
  )
}
